module.exports = __webpack_public_path__ + "media/images/expert-slide2-add0139d89b8c904b99c09980fc9878619fc8043dcd84bec370a110813d8b629.jpg";